import {UmpireImage} from '../umpire-image';

export interface UmpireTransmissionProvider {
  id: string;

  image: Partial<UmpireImage>;

  name: string | undefined;

  website_url: string | undefined;
}
